<template>
  <div>
        <h1>not found</h1>
    <p>0ops we couldn't find the page, go back
        <router-link to="/">home</router-link>

    </p>
  </div>
</template>

<script>
export default {
    
}
</script>

<style  scoped>
    div{
        justify-content:center
    }
</style>